import crawl4ai from '../../../packages/shared/crawl4ai-credit.json';
const base = '/assets/citation-licenses/';

export function CitationCredit() {
  return <p className="account-hint">© Frank Bennett — citeproc-js implements the Citation Style Language.{' '}
    <a href="https://citationstyles.org/" target="_blank" rel="noreferrer">citationstyles.org</a>{' · '}
    <a href="/licenses" target="_blank" rel="noreferrer">Software acknowledgements and source</a>
  </p>;
}

export function SoftwareAcknowledgements() {
  return <div className="account-shell portal-design">
    <header className="account-header"><a href="/home">Marvin</a></header>
    <main id="account-content" className="account-download-page">
      <section className="account-form-card">
        <h1>Software acknowledgements</h1>
        <CitationCredit/>
        <h2>Citation formatting</h2>
        <p>Marvin uses unmodified citeproc-js 2.4.63 under the Common Public Attribution License 1.0 (CPAL). The processor source is available below. Its licence gives you rights to use, modify and redistribute that component; Marvin’s own terms do not restrict those rights.</p>
        <ul>
          <li><a href={`${base}CPAL-1.0.txt`}>CPAL licence and attribution exhibits</a></li>
          <li><a href={`${base}citeproc-js-2.4.63.tar.gz.bin`} download="citeproc-js-2.4.63.tar.gz">Download complete citeproc-js 2.4.63 source</a></li>
          <li><a href={`${base}source-receipt.json`}>Source version and SHA-256 receipt</a></li>
          <li><a href={`${base}NOTICE.txt`}>Citation notices</a></li>
        </ul>
        <h2>Citation styles and locales</h2>
        <p>Unmodified Citation Style Language styles and locales retain their authors’ credits and are provided under Creative Commons Attribution-ShareAlike 3.0.</p>
        <ul>
          <li><a href={`${base}CC-BY-SA-3.0.txt`}>Creative Commons licence</a></li>
          <li><a href={`${base}CSL-LICENSE.txt`}>Citation Style Language notices</a></li>
          <li><a href={`${base}manifest.json`}>Pinned style and locale source files, authorship locations and hashes</a></li>
        </ul>
        <h2>Public-source retrieval</h2>
        <p>{crawl4ai.attribution}</p>
        <p>Marvin’s hosted retrieval service uses Crawl4AI 0.9.4. Its licence includes an additional attribution requirement.</p>
        <p><a href="/assets/service-licenses/crawl4ai-0.9.4-LICENSE.txt">Full Crawl4AI licence and attribution terms</a></p>
        <p>These acknowledgements cover citation processing and Crawl4AI. Other component licensing reviews are still in progress.</p>
      </section>
    </main>
  </div>;
}
